import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

export default function AboutUsTabs(props) {
  const { tabData = [] } = props;

  const [value, setValue] = React.useState('1');

  const styles = {
    tabHeader: {
      fontFamily: 'Raleway',
      '& .Mui-selected': {
        color: `black !important`
      },
      '& .MuiTabs-indicator': {
        backgroundColor: 'black'
      },
      '& .MuiTabs-scroller': {
        overflowX: 'scroll !important'
      }
    }
  };

  const { tabHeader = {} } = styles;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            sx={tabHeader}
            onChange={handleChange}
            aria-label="lab API tabs example"
          >
            <Tab label="Our Story" value="1" />
            <Tab label="Our Vision" value="2" />
            <Tab label="Our Mission" value="3" />
            <Tab label="Our Philosophy" value="4" />
          </TabList>
        </Box>
        {/* {tabData.map((data, index) => {
          return (
            <>
              <TabPanel key={`tab-child-${index}`} value={index + 1}>
                {data}
              </TabPanel>
            </>
          );
        })} */}
        <TabPanel sx={{ fontFamily: 'Raleway' }} value="1">
          {tabData[0]}
        </TabPanel>
        <TabPanel sx={{ fontFamily: 'Raleway' }} value="2">
          {tabData[1]}
        </TabPanel>
        <TabPanel sx={{ fontFamily: 'Raleway' }} value="3">
          {tabData[2]}
        </TabPanel>
        <TabPanel sx={{ fontFamily: 'Raleway' }} value="4">
          {tabData[3]}
        </TabPanel>
      </TabContext>
    </Box>
  );
}
